const Menu =  [
  // { header: 'Menu' },
  {
    title: '콜 관리',
    group: 'call',
    component: 'call',
    role: 'ROOT|OPER|MARKETER',
    items: [
      { name: 'realTimeCall', title: '실시간 콜 현황', component: 'components/realTimeCall' },
      { name: 'runningDrivers', title: '운행 중 택시 현황', component: 'components/runningDrivers' },
      { name: 'runningBanBanCalls', title: '운행 중 반반콜 현황', component: 'components/runningBanBanCalls' },
    ]
  },
  {
    title: '회원 관리',
    group: 'member',
    component: 'member',
    items: [
      { name: 'passengerMember', title: '승객 회원 관리', component: 'components/passengerMember', role: 'ROOT|OPER|MARKETER' },
      { name: 'driverMember', title: '기사 회원 관리', component: 'components/driverMember', role: 'ROOT|OPER|MARKETER|DRIVER_ADMIN' },
    ]
  },  
  {
    title: '이용이력 관리',
    group: 'usage',
    component: 'usage',
    role: 'ROOT|OPER|MARKETER',
    items: [
      { name: 'passengerUsageMember', title: '승객 이용이력 관리', component: 'components/passengerUsageHistory' },
      { name: 'passengerUsageProblem', title: '승객 문제발생 이용이력 관리', component: 'components/passengerUsageProblemHistory' },
      { name: 'driverUsageHistory', title: '기사 이용이력 관리', component: 'components/driverUsageHistory' },
    ]
  },  
  {
    title: '신고 관리',
    group: 'report',
    component: 'report',
    role: 'ROOT|OPER',
    items: [
      { name: 'passengerReport', title: '승객 신고 관리', component: 'components/passengerReport' },
    ]
  },  
  {
    title: '심사 관리',
    group: 'menu',
    name: 'Screening',
    role: 'ROOT|OPER|DRIVER_ADMIN',
  },
  {
    title: '결제 관리',
    group: 'payment',
    component: 'payment',
    role: 'ROOT|OPER',
    items: [
      { name: 'passengerPayment', title: '승객 결제 관리', component: 'components/passengerPayment' },
    ]
  },  
  {
    title: '쿠폰 관리',
    group: 'menu',
    name: 'Coupon',
    role: 'ROOT',
  },
  // {
  //   title: '프로모션 코드 관리',
  //   group: 'menu',
  //   name: 'PromotionCode',
  //   role: 'ROOT|MARKETER',
  // },
  {
    title: '승객 정산 관리',
    group: 'menu',
    name: 'PassengerSettlement',
    role: 'ROOT|OPER',
  },
  {
    title: '기사 정산 관리',
    group: 'settlement',
    component: 'settlement',
    role: 'ROOT',
    items: [
      { name: 'settlement', title: '기사 정산금액 조회', component: 'components/settlement' },
      { name: 'settlementDetails', title: '기사 정산금액 상세 조회', component: 'components/settlementDetails' },
    ]
  },
  {
    title: 'VOC',
    group: 'menu',
    name: 'Voc',
    role: 'ROOT|OPER',
  },
  {
    title: 'APP PUSH',
    group: 'menu',
    name: 'AppPush',
    role: 'ROOT|MARKETER',
  },
  {
    title: 'SMS',
    group: 'sms',
    component: 'sms',
    role: 'ROOT|OPER|MARKETER',
    items: [
      { name: 'sendingSMS', title: 'SMS 전송', component: 'components/sendingSMS' },
      { name: 'SMSList', title: 'SMS 전송 내역', component: 'components/SMSList' },
    ]
  },
  {
    title: '요금 시뮬레이션',
    group: 'simulation',
    name: 'Simulation',
    role: 'ROOT'
  },
  {
    title: '서비스 설정',
    group: 'menu',
    name: 'Server',
    role: 'ROOT'
  },
];
// reorder menu
// Menu.forEach((item) => {
//   if (item.items) {
//     item.items.sort((x, y) => {
//       let textA = x.title.toUpperCase();
//       let textB = y.title.toUpperCase();
//       return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
//     });
//   }
// });

export default Menu;



// WEBPACK FOOTER //
// ./src/api/menu.js